import { useEffect, useState } from "react";
import { Button } from "../components/Button";

type UpdateRegistration = {
  waiting: ServiceWorker | null;
};

/**
 * Controlled SW update UX: show a prompt; user reloads. No silent forced reload.
 */
export function ServiceWorkerUpdateBanner() {
  const [registration, setRegistration] = useState<UpdateRegistration | null>(
    null,
  );

  useEffect(() => {
    if (!("serviceWorker" in navigator)) {
      return;
    }

    let cancelled = false;

    void navigator.serviceWorker.getRegistration().then((reg) => {
      if (!reg || cancelled) {
        return;
      }

      const checkWaiting = () => {
        if (reg.waiting) {
          setRegistration({ waiting: reg.waiting });
        }
      };

      checkWaiting();
      reg.addEventListener("updatefound", () => {
        const installing = reg.installing;
        if (!installing) {
          return;
        }
        installing.addEventListener("statechange", () => {
          if (installing.state === "installed" && navigator.serviceWorker.controller) {
            checkWaiting();
          }
        });
      });
    });

    return () => {
      cancelled = true;
    };
  }, []);

  if (!registration?.waiting) {
    return null;
  }

  return (
    <div className="hw-update-banner" role="status">
      <span>Доступно обновление приложения.</span>
      <Button
        type="button"
        variant="ghost"
        onClick={() => {
          registration.waiting?.postMessage({ type: "SKIP_WAITING" });
          window.location.reload();
        }}
      >
        Обновить
      </Button>
    </div>
  );
}
